import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    noticeBoardListLoading: false,
    noticeBoardListSuccess: null,
    noticeBoardListError: '',
    getNoticeBoardLoading: false,
    getNoticeBoardSuccess: {},
    getNoticeBoardError: '',
    createNoticeBoardLoading: false,
    createNoticeBoardSuccess: {},
    createNoticeBoardError: '',
    termGoal: [],
    batches: [],
    smsCreateLoading: false,
    smsCreateSuccess: {},
    smsCreateError: "",
    smsListLoading: false,
    smsListSuccess: {},
    smsListError: "",
    smsDetailsLoading: false,
    smsDetailsSuccess: {},
    smsDetailsError: "",
    showNoticeBoardLoading: false,
    showNoticeBoardSuccess: null,
    showNoticeBoardError: '',
    smsListLogLoading: false,
    smsListLogSuccess: {},
    smsListLogError: "",
}

export const noticeBoardSlice = createSlice({
    name: 'noticeBoard',
    initialState,
    reducers: {
        setSMSdetailsLoading: (state, action) => {
            state.smsDetailsLoading = true;
            state.smsDetailsSuccess = {}
        },
        setSMSdetailsSuccess: (state, action) => {
            state.smsDetailsLoading = false
            state.smsDetailsSuccess = action.payload.data
        },
        setSMSdetailsFailure: (state, action) => {
            state.smsDetailsLoading = false
            state.smsDetailsSuccess = {}
            state.smsDetailsError = action.payload.message
        },
        setNoticeBoardListLoading: (state, action) => {
            state.noticeBoardListLoading = true;
            state.noticeBoardListSuccess = null;
            state.noticeBoardListError = '';
        },
        setNoticeBoardListSuccess: (state, action) => {
            state.noticeBoardListLoading = false;
            state.noticeBoardListSuccess = action.payload;
            state.noticeBoardListError = '';
        },
        setNoticeBoardListError: (state, action) => {
            state.noticeBoardListLoading = false;
            state.noticeBoardListSuccess = null;
            state.noticeBoardListError = action.payload;
        },
        // resetNoticeBoardData : (state) => {
        //     state.noticeBoardListLoading = false;
        //     state.noticeBoardListSuccess = null;
        //     state.noticeBoardListError = '';
        // }
        setGetNoticeBoardLoading: (state, action) => {
            state.getNoticeBoardLoading = true;
            state.getNoticeBoardSuccess = {};
            state.getNoticeBoardError = '';
        },
        setGetNoticeBoardSuccess: (state, action) => {
            state.getNoticeBoardLoading = false;
            state.getNoticeBoardSuccess = action.payload.data;
            state.getNoticeBoardError = '';
        },
        setGetNoticeBoardError: (state, action) => {
            state.getNoticeBoardLoading = false;
            state.getNoticeBoardSuccess = {};
            state.getNoticeBoardError = action.payload;
        },
        setCreateNoticeBoardLoading: (state, action) => {
            state.createNoticeBoardLoading = true;
            state.createNoticeBoardSuccess = {};
            state.createNoticeBoardError = '';
        },
        setCreateNoticeBoardSuccess: (state, action) => {
            state.createNoticeBoardLoading = false;
            state.createNoticeBoardSuccess = action.payload;
            state.createNoticeBoardError = '';
        },
        setCreateNoticeBoardError: (state, action) => {
            state.createNoticeBoardLoading = false;
            state.createNoticeBoardSuccess = {};
            state.createNoticeBoardError = action.payload;
        },
        setBatches: (state, action) => {
            state.batches = action.payload
        },
        resetDetails: (state, action) => {
            state.getNoticeBoardSuccess = {};
            state.createNoticeBoardSuccess = {}

        },
        // sms reducer part
        setSmsListLoading: (state, action) => {

            state.smsListLoading = true
            state.smsListSuccess = {}
            state.smsListError = ""

        },
        setSmsListSuccess: (state, action) => {

            state.smsListLoading = false
            state.smsListSuccess = action.payload
            state.smsListError = ""

        },
        setSmsListError: (state, action) => {
            state.smsListLoading = false
            state.smsListSuccess = {}
            state.smsListError = action.payload.message

        },
        setSmsCreateLoading: (state, action) => {
            state.smsCreateLoading = true;
            state.smsCreateSuccess = {};
            state.smsCreateError = ""
        },
        setSmsCreateSuccess: (state, action) => {
            state.smsCreateLoading = false;
            state.smsCreateSuccess = action.payload;
            state.smsCreateError = ""

        },
        setSmsCreateError: (state, action) => {
            state.smsCreateLoading = false;
            state.smsCreateSuccess = {};
            state.smsCreateError = action.payload.message

        },
        resetSMSdetails: (state, action) => {
            state.smsCreateSuccess = {}
        },
        setShowNoticeBoardLoading: (state) => {
            state.showNoticeBoardLoading = true;
            state.showNoticeBoardSuccess = {};
            state.showNoticeBoardError = '';
        },
        setShowNoticeBoardSuccess : (state, action) => {
            state.showNoticeBoardLoading = false;
            state.showNoticeBoardSuccess = action.payload;
            state.showNoticeBoardError = '';
        },
        setShowNoticeBoardError : (state, action) => {
            state.showNoticeBoardLoading = false;
            state.showNoticeBoardSuccess = {};
            state.showNoticeBoardError = action.payload;
        },
        setSmsLogListLoading: (state, action) => {
            state.smsListLogLoading = true
            state.smsListLogSuccess = {}
            state.smsListLogError = ""

        },
        setSmsLogListSuccess: (state, action) => {
            state.smsListLogLoading = false
            state.smsListLogSuccess = action.payload
            state.smsListLogError = ""

        },
        setSmsLogListError: (state, action) => {
            state.smsListLoading = false
            state.smsListLogSuccess = {}
            state.smsListLogError = action.payload.messaLogge

        },
    },
})

export const {
    setCreateNoticeBoardLoading, setCreateNoticeBoardSuccess,
    setCreateNoticeBoardError, setNoticeBoardListLoading,
    setNoticeBoardListSuccess, setNoticeBoardListError,
    setGetNoticeBoardLoading, setGetNoticeBoardSuccess,
    setGetNoticeBoardError, setBatches, resetBatches,
    resetDetails,
    resetSMSdetails,
    setSmsListLoading,
    setSmsListSuccess,
    setSmsListError,
    setSmsCreateLoading,
    setSmsCreateSuccess,
    setSmsCreateError,
    setSMSdetailsLoading,
    setSMSdetailsSuccess,
    setSMSdetailsFailure,
    setShowNoticeBoardError, setShowNoticeBoardSuccess, setShowNoticeBoardLoading,
    setSmsLogListLoading,
    setSmsLogListSuccess,
    setSmsLogListError,
} = noticeBoardSlice.actions

export default noticeBoardSlice.reducer;